import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const QUICK_COMPLETE_USER_TASK = 'QUICK_COMPLETE_USER_TASK';


export const service = async (task) => {
  const options: object = {
    url:  "/Api/UserTasks/QuickCompleteUserTask" ,
    method: "POST",
    body: JSON.stringify(task),
    ...getDefaultOptions(),
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(QUICK_COMPLETE_USER_TASK, service, mock);
